import './header/draft/draft-header.css';
import { TopBar } from './header/draft/TopBar';

/** Draft 헤더 — 스타일은 draft-header.css 만 사용 (실서버 site-topbar CSS 미사용) */
export default function Header() {
  return (
    <div className="soundpill-draft-header fixed top-0 left-0 right-0 z-50 max-md:hidden w-full">
      <TopBar showNavLinks />
    </div>
  );
}
